export const validateCompanyDocument = (document: string, documentType: string) => {
  switch (documentType) {
    case 'CUIT':
      return validateCUIT(document);
    case 'NIT':
      // NIT validation is currently only validating length
      return document.length === 11;
    case 'CNPJ':
      return validateCNPJ(document);
    case 'RFC':
      return validateRFC(document);
  }
  return false;
};

export const validateCNPJ = (cnpj: string) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) return false;

  return true;
};

// Argentina
export const validateCUIT = (cuit: string) => {
  const document = cuit.replace(/[^\d]+/g, '');
  const digit = parseInt(document[10]);

  if (document === '' || document.length !== 11) {
    return false;
  }
  const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let total = 0;

  for (let i = 0; i < mult.length; i++) {
    total += parseInt(document[i]) * mult[i];
  }

  const mod = total % 11;
  const calculatedDigit = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;

  return calculatedDigit === digit;
};

// Colombia
export const validateNIT = (nit: string) => {
  const cleanDocument = nit.replace(/[^\d]+/g, '');

  const document = cleanDocument.substring(0, cleanDocument.length - 1);
  const digit = parseInt(cleanDocument[cleanDocument.length - 1]);

  if (document === '' || (cleanDocument.length !== 10 && cleanDocument.length !== 15)) {
    return false;
  }
  const shortNIT = document.length === 9;

  let multiplier = [3, 7, 13, 17, 19, 23, 29, 37, 41];

  if (!shortNIT) {
    multiplier = multiplier.concat([43, 47, 53, 59, 67, 71]);
  }

  let total = 0;

  for (let i = 0; i < document.length; i++) {
    const temp = Math.trunc(Number(document[document.length - 1 - i]));
    total += temp * multiplier[i];
  }

  const resto = total % 11;
  const calculatedDigit = resto > 1 ? 11 - resto : resto;

  return calculatedDigit === digit;
};

// Mexico
export const validateRFC = (rfc: string) => {
  const regex = /^[A-Za-z]{3}[ |-]{0,1}[0-9]{6}[ |-]{0,1}[0-9A-Za-z]{3}$/g;
  const res = rfc.match(regex);

  return res ? res?.length > 0 : false;
};
